import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface DashboardState {
  summary: any | null;
  trend: any[] | null;
  religion: any[] | null;
  partyCategory: any[] | null;
  purpose: any[] | null;
  tables: any | null;
  scriptureReferences: any[] | null;
  financialStatements: {
    balanceSheet: {
      assets: { accountName: string; amount: number }[];
      liabilities: { accountName: string; amount: number }[];
      totalAssets: number;
      totalLiabilities: number;
    } | null;
    profitLoss: {
      income: { accountName: string; amount: number }[];
      expenses: { accountName: string; amount: number }[];
      totalIncome: number;
      totalExpenses: number;
      netProfit: number;
    } | null;
  } | null;
}

const initialState: DashboardState = {
  summary: null,
  trend: null,
  religion: null,
  partyCategory: null,
  purpose: null,
  tables: null,
  scriptureReferences: null,
  financialStatements: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardData: (state, action) => {
      state.summary = action.payload.summary;
      state.trend = action.payload.trend;
      state.religion = action.payload.religion;
      state.partyCategory = action.payload.partyCategory;
      state.purpose = action.payload.purpose;
      state.tables = action.payload.tables;
      state.scriptureReferences = action.payload.scriptureReferences;
      state.financialStatements = action.payload.financialStatements;
    },
    resetDashboard: () => initialState,
  },
});

export const { setDashboardData, resetDashboard } = dashboardSlice.actions;

export const getDashboardSummary = (state: RootState) => state.dashboard.summary;
export const getDashboardTrend = (state: RootState) => state.dashboard.trend;
export const getDashboardReligion = (state: RootState) => state.dashboard.religion;
export const getDashboardPartyCategory = (state: RootState) => state.dashboard.partyCategory;
export const getDashboardPurpose = (state: RootState) => state.dashboard.purpose;
export const getDashboardTables = (state: RootState) => state.dashboard.tables;
export const getDashboardScriptureReferences = (state: RootState) => state.dashboard.scriptureReferences;
export const getDashboardFinancialStatements = (state: RootState) => state.dashboard.financialStatements;

export default dashboardSlice.reducer;
